import React from "react";
import Card from "react-bootstrap/Card";
import CardGroup from "react-bootstrap/CardGroup";
import "bootstrap/dist/css/bootstrap.min.css";
import { Cardy, Wrapper, TopLine } from "./ACard.elements";
import "./ACard.css";

function ACard() {
  return (
    <>
      <Wrapper>
        <TopLine lightTopLine="true">Our Features</TopLine>
        <Cardy>
          <CardGroup>
            <Card className="card">
              <Card.Img variant="top" src={require("../../images/6.svg")} />
              <Card.Body>
                <Card.Title className="hea"> Data Vault </Card.Title>
                <Card.Text>
                  Securely store and manage your identity documents and digital
                  assets in your IDentrix identity wallet
                </Card.Text>
              </Card.Body>
            </Card>

            <Card className="card">
              <Card.Img variant="top" src={require("../../images/1.svg")} />
              <Card.Body>
                <Card.Title className="hea">One-Click Solutions</Card.Title>
                <Card.Text>
                  One Click Sign-Up/ Login and Authorization solutions for all
                  the services on the Internet with the IDentrix wallet
                </Card.Text>
              </Card.Body>
            </Card>

            <Card className="card">
              <Card.Img variant="top" src={require("../../images/2.svg")} />
              <Card.Body>
                <Card.Title className="hea">IDentrix wallet</Card.Title>
                <Card.Text>
                  Peer to Peer digital credentials sharing through Identity
                  wallet when proof of verification is required
                </Card.Text>
              </Card.Body>
            </Card>
          </CardGroup>
          <CardGroup>
            <Card className="card">
              <Card.Img variant="top" src={require("../../images/4.svg")} />
              <Card.Body>
                <Card.Title className="hea">Tamper Proof</Card.Title>
                <Card.Text>
                  The Identity transactions on the distributed ledger are
                  strongly immutable and no personal data is stored on the
                  Blockchain
                </Card.Text>
              </Card.Body>
            </Card>

            <Card className="card">
              <Card.Img variant="top" src={require("../../images/3.svg")} />
              <Card.Body>
                <Card.Title className="hea">Extremely Secure</Card.Title>
                <Card.Text>
                  All the Identity transactions on the network are Extremely
                  secure and tamper proof, as they are cryptographically
                  encrypted
                </Card.Text>
              </Card.Body>
            </Card>

            <Card className="card">
              <Card.Img variant="top" src={require("../../images/5.svg")} />
              <Card.Body>
                <Card.Title className="hea">Decentralized </Card.Title>
                <Card.Text>
                  The centralized databases of personal data are giant honeypots
                  that have led to some of the biggest data breaches in history.
                </Card.Text>
              </Card.Body>
            </Card>
          </CardGroup>
        </Cardy>
      </Wrapper>
    </>
  );
}

export default ACard;
